import {TokenService} from '../TokenService';

import {useDialogCrup} from '../../../../shared/hooks/DialogCrup';

export const CreateNCCA = ({header, dataKey, refreshLazyData}) => {

  const {render, create} = useDialogCrup({
    header,
    dataKey,
    width: '45rem',
    fields: [
      {type: 'custom', className: 'md:col-12 text-center mb-3', body: (<img src="/images/NCCA-logo.png" alt=""/>)},
      {type: 'custom', className: 'md:col-12 text-center mb-0', body: <h4 className="mb-1">Thiết lập kết nối đến máy chủ ký số</h4>},
      {type: 'custom', className: 'md:col-12 text-center mb-5', body: <i>Thông tin kết nối do đơn vị cung cấp chứng thư số cấp</i>},
      {field: 'authCode', header: 'ID Ứng dụng', required: true, InputTextProps: {maxLength: 50}, className: 'md:col-12'},
      {field: 'passwordCer', header: 'Mật khẩu chứng thư số', type: 'Password', required: true, className: 'md:col-12'}
    ],
    createItem: (item) => {
      item.tokenType = 3;
      return TokenService.create(item);
    },
    refreshLazyData
  });

  return {render, open: create};

}